import { FC } from 'react'

import Clevertap from '@/analytics/clevertap/index'
import DateSelector from '@/components/srp/DateSelector'
import { isTravelMaxSale } from '@/utils/common'

interface DateSelectorWrapper {
    isLoading: boolean
    isRT: boolean
    searchQuery: any
    resetSearch: (query: any) => void
    showOnwardPriceTooltip?: boolean
    showReturnPriceTooltip?: boolean
    sortedFilteredCards: any
    toastHandler: (msg: string) => void
    isSrpRevamp?: boolean
}

const DateSelectorWrapper: FC<DateSelectorWrapper> = ({
    isLoading,
    isRT,
    searchQuery,
    resetSearch,
    showOnwardPriceTooltip,
    showReturnPriceTooltip,
    sortedFilteredCards,
    toastHandler,
    isSrpRevamp = false
}) => {
    const onDateChange = (query: object) => {
        Clevertap.event('Air_UI_Action', {
            actionName: 'SRP_Calendar_Ribbon_Click'
        })
        resetSearch(query)
    }
    return !isLoading && !(isRT && searchQuery.intl === 'y') && !(searchQuery.isCfw === 'true') ? (
        !isRT ? (
            <DateSelector
                isPerAdult={isTravelMaxSale()?false: true}
                isSrpRevamp={isSrpRevamp}
                journeyType="onward"
                screenType="fullScreen"
                searchParams={searchQuery}
                showPriceTooltip={showOnwardPriceTooltip}
                sortedFilteredCards={sortedFilteredCards}
                toastHandler={toastHandler}
                onDateChange={onDateChange}
            />
        ) : (
            <div className="flex flex-row">
                <div className="w-50p pr-2">
                    <DateSelector
                        isPerAdult={isTravelMaxSale()?false:true}
                        journeyType="onward"
                        screenType="splitScreen"
                        searchParams={searchQuery}
                        showPriceTooltip={showOnwardPriceTooltip}
                        sortedFilteredCards={sortedFilteredCards}
                        toastHandler={toastHandler}
                        onDateChange={onDateChange}
                    />
                </div>
                <div className="w-50p pl-3">
                    <DateSelector
                        isPerAdult={isTravelMaxSale()?false:true}
                        journeyType="return"
                        screenType="splitScreen"
                        searchParams={searchQuery}
                        showPriceTooltip={showReturnPriceTooltip}
                        sortedFilteredCards={sortedFilteredCards}
                        toastHandler={toastHandler}
                        onDateChange={onDateChange}
                    />
                </div>
            </div>
        )
    ) : null
}

export default DateSelectorWrapper
